import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/[locale]/dental/FullMouthRequestForm.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/[locale]/dental/ServicerequestForm.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/LocaleLink.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
